import { SlackFeed } from "shared/components/slackfeeds/slackFeed";
import { DashboardBlock } from "../layout/DashboardBlock";

/**
 * Wrapper for the Slack Feed
 * Uses consistent dashboard block styling
 */
export const SlackFeedBlockNew = () => {
  return (
    <DashboardBlock>
      <SlackFeed channelName="aankondigingen" channelId="C062ZBXHVS6" />
    </DashboardBlock>
  );
};

